import React from 'react'
import { SLIDERS_API } from '../../../Utilities/APIs'
import IPCRUD from '../../Partials/Layouts/CRUDs/CRUDLayouts/IPCRUD/IPCRUD'

function Sliders() {
  return (
    <IPCRUD
        // common props
        api={SLIDERS_API}
        screenTopicSingular={'Slider'}
        screenTopicPlural={'Sliders'}
        
        // crud header props
        showTotalInHeading
        
        // crud props
        allowCreate
        allowUpdate
        allowDelete
        
        // field props
        maxPrecedence={4}
    />
  )
}

export default Sliders